import { useNavigate, useLocation } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

import Img from "../../../assets/acg-logo.avif";

const DesktopHeader = ({ theme }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNav = (page) => () => {
    window.scrollTo(0, 0);
    navigate(page);
  };

  const isLoginPage = location.pathname === "/";

  return (
    <AppBar
      position="sticky"
      elevation={0}
      sx={{
        bgcolor: "rgba(255,255,255,0.92)",
        color: "black",
        borderBottom: "1px solid",
        borderColor: "divider",
        backdropFilter: "blur(8px)",
      }}
    >
      <Toolbar sx={{ minHeight: 64, px: { xs: 2, md: 3 } }}>
        <Box
          sx={{
            width: 44,
            height: 44,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mr: 1.5,
            p:2
          }}
        >
          <img
            src={Img}
            alt="ACG"
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        </Box>
        <Box sx={{ flexGrow: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
            ACG Sales Tool
          </Typography>
        </Box>
        {!isLoginPage ? (
          <Button
            variant="contained"
            color="primary"
            onClick={handleNav("/")}
            theme={theme}
            sx={{
              textTransform: "none",
              fontWeight: 600,
              borderRadius: "10px",
              px: 2,
            }}
          >
            Login
          </Button>
        ) : null}
      </Toolbar>
    </AppBar>
  );
};

export default DesktopHeader;
